import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { Signer } from '@tokenlon/sdk';
export var signMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, message) {
    var signer;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!provider || !message)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.next = 4;
            return new Signer(provider).getSigner();

          case 4:
            signer = _context.sent;
            return _context.abrupt("return", signer.signMessage(message));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function signMessage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();